module.exports = __webpack_public_path__ + "c21c92b1.svg";